import {
  regex_default
} from "./chunk-B3QUQ4UZ.mjs";

// src/supported-browsers/isBrowserSupported.ts
var isBrowserSupported = (userAgent) => regex_default.test(userAgent);
var isBrowserSupported_default = isBrowserSupported;

export {
  isBrowserSupported_default
};
//# sourceMappingURL=chunk-KJN76V4X.mjs.map